import { FormikProps } from "formik";
import React from "react";
import { FC } from "react";
import { FormGroupInput, propsInterfaceFormGroupInput } from "./FormGroupInput";

const ArrayInput: FC<ArrayInputProps> = (props) => {
    let classArrayInput = "row " + props.classContainer
    return (
        <div className={classArrayInput}>
            {props.arrayInput?.map((item: propsInterfaceFormGroupInput, key: number) => {
                const id = item.id || item.advanceOptions?.id
                return (
                    <FormGroupInput
                        label={item.label}
                        onClickLabel={item.onClickLabel}
                        key={key?.toString()}
                        type={item.type}
                        className={item.className}
                        placeholder={item.placeholder}
                        maxLength={item.maxLength}
                        campo={item.campo}
                        treeData={item.treeData}
                        style={item.style}
                        id={(id + key.toString())}
                        readonly={item.readonly}
                        readonlyCheckbox={item.readonlyCheckbox}
                        disabled={item.disabled}
                        advanceOptions={item.advanceOptions}
                        isSwitch={item.isSwitch}
                        campoChk={item.campoChk}
                        columInput={item.columInput}
                        onChange={item.onChange}
                        onChangeTree={item.onChangeTree}
                        onBlur={item.onBlur}
                        onClick={item.onClick}
                        onInput={item.onInput}
                        hideInput={item.hideInput}
                        arrayInput={props.arrayInput}
                        onChangeFile={item.onChangeFile}
                        onClearFile={item.onClearFile}
                        color={item.color}
                        onChangeColor={item.onChangeColor}
                        fileRef={item.fileRef}
                        min={item.min}
                        max={item.max}
                    />
                )
            })}
        </div>
    )
}
interface ArrayInputProps {
    arrayInput?: propsInterfaceFormGroupInput[],
    classContainer?: string,
    formikProps?: FormikProps<any>
}
export default React.memo(ArrayInput)